import { useMemo } from 'react';

import { Funeral, pickupLocation, PickupLocation } from './pickupLocation';

/**
 * Where a transfer starts.
 *
 * Reads only what the case itself holds:
 *   1. `pickup_address` — collection somewhere other than the place of death
 *   2. `place_of_death_address` — the address, whatever the type of place
 *
 * It deliberately does NOT fall back to the matching `places` row for a
 * facility death. The facility's address is meant to be copied onto the case
 * when the place of death is chosen, so reading it back out of `places` would
 * hide the cases where that copy did not happen — and would quietly price from
 * an address the case does not actually show. A case with no address is a data
 * problem to fix at the source, and saying so is more useful than guessing.
 *
 * A hook rather than a plain call so the resolution has one home as this grows,
 * and so callers all read the same answer.
 */
export function usePickupLocation(
  funeral: Funeral | null | undefined,
): PickupLocation | null {
  return useMemo(() => (funeral ? pickupLocation(funeral) : null), [funeral]);
}
